module.exports = __webpack_public_path__ + "img/logo_02.caef993c.png";